import { CORES_SITUACAO } from "../shared";

export default function Etiqueta({ texto, situacao = 'neutro' }) {
    const cores = CORES_SITUACAO[situacao] || CORES_SITUACAO.neutro;

    return (
        <span style={{
            backgroundColor: cores.fundo,
            border: `1px solid ${cores.borda}`,
            borderRadius: 12,
            color: cores.texto,
            display: 'inline-block',
            fontSize: 12,
            fontWeight: 700,
            padding: '3px 9px',
            whiteSpace: 'nowrap',
        }}>
            {texto}
        </span>
    );
}
